import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { registerUser } from "../../Redux/Actions";
import Footer from "../Footer/Footer";
// import Header from "../Header/Header";
import ScrolltoTop from "../Scrolltotop/ScrolltoTop";
import SubFooter from "../SubFooter/SubFooter";
import TopNav from "../TopNav/TopNav";
import "./Register.css";
import NewHeader from "../NewHeader/NewHeader";

function Register() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");

  const registerResponse = useSelector((state) => state.registerUser);
  const { loading, registerUserResponse } = registerResponse;

  const history = useHistory();
  const dispatch = useDispatch();

  const handleSubmit = () => {
    const registerModel = {
      user: {
        email: email,
        password: password,
        phonenumber: phoneNumber,
        usergroup: "Customer",
        fullname: name,
      },
    };
    dispatch(registerUser(JSON.stringify(registerModel)));
  };

  useEffect(() => {
    if (registerUserResponse && registerUserResponse.user) {
      localStorage.setItem("user", JSON.stringify(registerUserResponse.user));
      // history.push("/");
      window.location.href = process.env.RAZZLE_APP_BASE_URL;
    }
  }, [loading]);

  const handleNameChange = (event) => {
    setName(event.target.value);
  };
  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };
  const handlePhoneNumberChange = (event) => {
    setPhoneNumber(event.target.value);
  };
  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
  };

  return (
    <React.Fragment>
      <NewHeader />
      <div className="RegisterContainer">
        <div className="welcome-redcilffe">
          <div className="row">
            <h2>Welcome to Redcliffe </h2>
          </div>
          <div className="login-row">
            <div className="left">
              <h1>image</h1>
              <img />
            </div>
            <div className="right">
              <div className="loginform">
                <div>
                  <h1>REGISTER</h1>
                  <p>Please enter your Mobile Number to proceed</p>
                  <img />
                </div>
                <form>
                  <input
                    onChange={handleNameChange}
                    value={name}
                    placeholder="Full Name"
                  ></input>
                  <input
                    onChange={handleEmailChange}
                    value={email}
                    placeholder="Email"
                  ></input>
                  <input
                    type="password"
                    onChange={handlePasswordChange}
                    value={password}
                    placeholder="Password"
                  ></input>
                  <input
                    onChange={handlePhoneNumberChange}
                    value={phoneNumber}
                    placeholder="Phone Number"
                  ></input>
                </form>
                <button onClick={handleSubmit}>Register Now</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ScrolltoTop />
      <Footer />
      <SubFooter />
    </React.Fragment>
  );
}

export default {
  component: Register,
};
